<template>
    <validation-provider :rules="rules" :name="name" v-bind="$attrs" v-slot="{ errors, valid, invalid, validated }">
      <b-form-group>
        <slot name="label">
          <label v-if="label" :class="labelClasses">
            {{ label }}
          </label>
        </slot>
        <div
          :class="[
            { 'input-group': true }, // Always show input group
            { focused: focused },
            { 'input-group-alternative': alternative },
            { 'has-label': label || $slots.label },
            inputGroupClasses
          ]"
        >
        <div class="input-group-prepend" style="display: flex;">
    <select v-model="selectedCountry" class="form-control" style="border-top-right-radius: 0 !important; border-bottom-right-radius: 0 !important; flex: 1;">
        <option disabled selected value="">Country Code</option>
        <option v-for="(country, index) in countries" :key="index" :value="country.code">
            {{ country.name }} ({{ country.code }})
        </option>
    </select>

    <input
        v-model="phoneNumber"
        :type="type"
        v-on="listeners"
        v-bind="$attrs"
        :valid="valid"
        :required="required"
        class="form-control"
        :class="[
            { 'is-valid': valid && validated && successMessage },
            { 'is-invalid': invalid && validated },
            inputClasses
        ]"
        style="border-top-left-radius: 0 !important; border-bottom-left-radius: 0 !important;  flex: 1; margin-left: -1px; width: 300px"
    />
</div>

          <div v-if="appendIcon || $slots.append" class="input-group-append">
            <span class="input-group-text">
              <slot name="append">
                <i :class="appendIcon"></i>
              </slot>
            </span>
          </div>
          <slot name="infoBlock"></slot>
        </div>
        <slot name="success">
          <div class="valid-feedback" v-if="valid && validated && successMessage">
            {{ successMessage }}
          </div>
        </slot>
        <slot name="error">
          <div v-if="errors[0]" class="invalid-feedback" style="display: block;">
            {{ errors[0] }}
          </div>
        </slot>
      </b-form-group>
    </validation-provider>
  </template>
  
  <script>
  export default {
    inheritAttrs: false,
    name: 'phone-input',
    props: {
      required: {
        type: Boolean,
        description: 'Whether input is required (adds an asterix *)'
      },
      alternative: {
        type: Boolean,
        description: 'Whether input is of alternative layout'
      },
      label: {
        type: String,
        description: 'Input label (text before input)'
      },
      error: {
        type: String,
        description: 'Input error (below input)'
      },
      successMessage: {
        type: String,
        description: 'Input success message',
        default: ''
      },
      labelClasses: {
        type: String,
        description: 'Input label css classes',
        default: 'form-control-label'
      },
      inputClasses: {
        type: String,
        description: 'Input css classes'
      },
      inputGroupClasses: {
        type: String,
        description: 'Input group css classes'
      },
      value: {
        type: String,
        description: 'Input value'
      },
      type: {
        type: String,
        description: 'Input type',
        default: 'text'
      },
      appendIcon: {
        type: String,
        description: 'Append icon (right)'
      },
      prependIcon: {
        type: String,
        description: 'Prepend icon (left)'
      },
      rules: {
        type: [String, Array, Object],
        description: 'Vee validate validation rules',
        default: ''
      },
      name: {
        type: String,
        description: 'Input name (used for validation)',
        default: ''
      }
    },
    data() {
      return {
        focused: false,
        selectedCountry: '',
        countries: [
          { code: '+1', name: 'United States' },
          { code: '+44', name: 'United Kingdom' },
          { code: '+61', name: 'Australia' },
          // Add more countries as needed
        ],
        phoneNumber: this.value || '' // Initialize phoneNumber with value prop or empty string
      };
    },
    computed: {
      listeners() {
        return {
          ...this.$listeners,
          input: this.updateValue,
          focus: this.onFocus,
          blur: this.onBlur
        };
      }
    },
    methods: {
        updateValue(evt) {
            this.phoneNumber = evt.target.value;
            // Emit combined value with country code
            this.$emit('input', this.selectedCountry + ' ' + this.phoneNumber);
        },
        onFocus(evt) {
            this.focused = true;
            this.$emit('focus', evt);
        },
        onBlur(evt) {
            this.focused = false;
            this.$emit('blur', evt);
        }
    }

  };
  </script>
  